export default __webpack_public_path__ + "static/media/Mobile 2.dc4dfa67.png";